import { render, staticRenderFns } from "./CaseFiles.vue?vue&type=template&id=568fbbc6&scoped=true&"
import script from "./CaseFiles.vue?vue&type=script&lang=ts&"
export * from "./CaseFiles.vue?vue&type=script&lang=ts&"
import style0 from "./CaseFiles.vue?vue&type=style&index=0&id=568fbbc6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568fbbc6",
  null
  
)

export default component.exports